import { render, staticRenderFns } from "./PromoOdr.vue?vue&type=template&id=edd2ee04&scoped=true&"
import script from "./PromoOdr.vue?vue&type=script&lang=js&"
export * from "./PromoOdr.vue?vue&type=script&lang=js&"
import style0 from "./PromoOdr.vue?vue&type=style&index=0&id=edd2ee04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd2ee04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edd2ee04')) {
      api.createRecord('edd2ee04', component.options)
    } else {
      api.reload('edd2ee04', component.options)
    }
    module.hot.accept("./PromoOdr.vue?vue&type=template&id=edd2ee04&scoped=true&", function () {
      api.rerender('edd2ee04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/PromoOdr.vue"
export default component.exports